import React from "react";
import {
  FormControlLabel,
  Typography,
  Button,
  Checkbox,
  FormGroup,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
function ViewResult() {
  return (
    <>
      <Typography  align="center">
      - 코리아크레딧뷰로㈜ 고유식별정보처리 동의 -
•	에스케이텔레콤(주), (주)케이티, LG유플러스(주) (이하 "본인확인기관")가 코리아크레딧뷰로(주) (이하 "회사")를 통해 제공하는 휴대폰 본인인증 서비스와 관련하여 고객으로부터 수집한 고유식별정보를 이용하거나 타인에게 제공할 때에는 '정보통신망 이용촉진 및 정보보호 등에 관한 법률'(이하 "정보통신망법")에 따라 고객의 동의를 얻어야 합니다.

[고유식별정보의 수집 및 이용 목적]
 "본인확인기관"은 휴대폰 본인인증 서비스 제공시, 아래 두 가지 목적을 위해 고객의 고유식별정보를 처리할 수 있습니다. 
•	1. 정보통신망법 제23조의2 제2항에 따라 인터넷상에서 주민등록번호를 입력하지 않고도 본인임을 확인할 수 있는 휴대폰 본인인증 서비스를 제공하기 위해 고유식별정보를 이용
•	2. '본인확인기관 지정 등에 관한 기준(방송통신위원회 고시)'에 따라 "회사"와 계약한 정보통신서비스 제공자의 연계서비스 및 중복가입확인을 위해 필요한 경우, 다른 본인확인기관이 아래의 고유식별정보를 제공받아 처리하기 위함.

[수집하는 개인정보의 항목]
•	(1) 주민등록번호(내국인) 
•	(2) 외국인등록번호(국내거주외국인) 

[개인정보의 보유 및 이용기간]
•	"회사"는 휴대폰 본인확인 서비스 제공, 연계서비스 및 중복가입확인을 위하여 필요한 기간 동안 이용자의 고유식별정보를 보유합니다..
•	상기 내용과 같이 고유식별정보의 처리에 동의합니다.

※ 본 고유식별정보 처리동의는 거부할 수 있으나, 거부 시에는 휴대폰본인확인서비스를 제공받으실 수 없습니다.


      </Typography>
      <hr />
    </>
  );
}
function JeonMoon3(props) {
  const classes = props.useStyles();
  const [showResults, setShowResults] = React.useState(false);
  const onView = (e) => {
    e.preventDefault();
    setShowResults(!showResults);
  };
  return (
    <>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.JeonMoon3}
              disabled={props.SelfCertification}
              onChange={(e) => {
                props.onChangeJeonMoon3Yn(e.target.checked);
              }}
              name="Marketing"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [필수]고유식별 정보 처리 동의
            </Typography>
          }
        />
        <Button
          className={classes.Button}
          variant="text"
          color="primary"
          type="submit"
          onClick={onView}
          startIcon={<VisibilityIcon />}
        >
          내용보기
        </Button>
      </FormGroup>

      <hr />
      {showResults ? <ViewResult /> : null}
    </>
  );
}
export default JeonMoon3;
